// eslint-disable-next-line unicorn/prefer-module, unicorn/prefer-node-protocol
const fs = require('fs').promises;

const getMessages = async (locale) => JSON.parse(
  await fs.readFile((`./lang/${locale || 'en-IE'}.json`)),
);

// eslint-disable-next-line unicorn/prefer-module
module.exports = {
  getMessages,
};
